import React from "react";
import { companyConfig } from "../config/company";
import "./Privacy.css";

const Privacy: React.FC = () => {
  return (
    <section className="privacy">
      <div className="privacy-container">
        <h1>Datenschutzerklärung</h1>

        <h2>1. Datenschutz auf einen Blick</h2>
        <h3>Allgemeine Hinweise</h3>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können.
        </p>

        <h3>Datenerfassung auf dieser Website</h3>
        <h4>
          Wer ist verantwortlich für die Datenerfassung auf dieser Website?
        </h4>
        <p>
          Die Datenverarbeitung auf dieser Website erfolgt durch den
          Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser
          Website entnehmen.
        </p>

        <h2>2. Cookies und Web-Analytics</h2>
        <h3>Cookies</h3>
        <p>
          Unsere Website verwendet Cookies. Bei Cookies handelt es sich um
          kleine Textdateien, die auf Ihrem Endgerät gespeichert werden. Ihr
          Browser greift auf diese Dateien zu.
        </p>

        <h4>Welche Cookies verwenden wir?</h4>
        <ul>
          <li>
            <strong>Notwendige Cookies:</strong> Diese Cookies sind für den
            Betrieb der Website erforderlich und können nicht deaktiviert
            werden. Sie werden nur als Reaktion auf von Ihnen getätigte Aktionen
            gesetzt, wie etwa dem Festlegen Ihrer Datenschutzeinstellungen oder
            dem Ausfüllen von Formularen.
          </li>
          <li>
            <strong>Analyse-Cookies:</strong> Diese Cookies ermöglichen es uns,
            Besuche und Verkehrsquellen zu zählen, damit wir die Leistung
            unserer Website messen und verbessern können. Sie helfen uns zu
            verstehen, welche Seiten am beliebtesten sind und wie sich Besucher
            auf der Website bewegen.
          </li>
          <li>
            <strong>Marketing-Cookies:</strong> Diese Cookies können von unseren
            Werbepartnern über unsere Website gesetzt werden. Sie können von
            diesen Unternehmen verwendet werden, um ein Profil Ihrer Interessen
            zu erstellen und Ihnen relevante Werbung auf anderen Websites zu
            zeigen.
          </li>
        </ul>

        <h3>Cookie-Einwilligung</h3>
        <p>
          Beim ersten Besuch unserer Website zeigen wir Ihnen einen
          Cookie-Banner. Hier können Sie festlegen, welche Cookies Sie
          akzeptieren möchten. Notwendige Cookies werden in jedem Fall gesetzt.
          Ihre Einwilligung können Sie jederzeit in den Cookie-Einstellungen
          ändern oder widerrufen.
        </p>

        <h2>3. Ihre Rechte</h2>
        <p>Sie haben folgende Rechte:</p>
        <ul>
          <li>Recht auf Auskunft</li>
          <li>Recht auf Berichtigung</li>
          <li>Recht auf Löschung</li>
          <li>Recht auf Einschränkung der Verarbeitung</li>
          <li>Recht auf Datenübertragbarkeit</li>
          <li>Widerspruchsrecht</li>
        </ul>

        <h2>4. Kontakt</h2>
        <p>
          Bei Fragen zur Verarbeitung Ihrer personenbezogenen Daten können Sie
          sich direkt an uns wenden:
        </p>
        <p>
          {companyConfig.name}
          <br />
          {companyConfig.contact.address.street}
          <br />
          {companyConfig.contact.address.zip}{" "}
          {companyConfig.contact.address.city}
          <br />
          E-Mail: {companyConfig.contact.email}
        </p>
      </div>
    </section>
  );
};

export default Privacy;
